const CURRENT_CACHED_LOCATION_VERSION = 'current-cached-location-version';
const CURRENT_CACHED_LOCATION_LANG = 'current-cached-location-lang';
const CURRENT_CACHED_LOCATION = 'current-cached-location';
/**
 * 根据分组Map和顶层数据对data数据递归的进行转换
 * @param prevData {Object[]} 最外层地区数据数组
 * @param dataMap {Object} 以父层为key的分组数组
 * @returns {Object[]} 返回处理后的数组
 */
function recursiveCovertLocationData(prevData, dataMap) {
    if(prevData === undefined) {
        return prevData;
    };
    for (let i = 0; i < prevData.length; i++) {
        if (prevData[i][3] === 1) {
            const result = recursiveCovertLocationData(
                dataMap[prevData[i][0]],
                dataMap
            );
            prevData[i] = [prevData[i][0], prevData[i][1], result];
        }else{
            prevData[i] = [prevData[i][0], prevData[i][1]];
        }
    }
    return prevData;
}

/**
 * 将原始的data类型进行转换至多维数组
 * @param data {Object[]} 原始的一维地区数组
 * @returns {Object[]} 处理之后的多维数组
 */
export function convertDataToLocationNeeded(data) {
    const helper = {};
    for (let i = 0; i < data.length; i++) {
        if (helper[data[i][2]] === undefined) {
            helper[data[i][2]] = [];
        }
        helper[data[i][2]].push(data[i].map(d => (Array.isArray(d) ? d[0] : d)));
    }
    return recursiveCovertLocationData(helper[''], helper);
}

function getLocationDataFromCache(version) {
    return new Promise((resolve, reject) => {
        const cache = localStorage.getItem(CURRENT_CACHED_LOCATION);
        if(cache == null) {
            reject(`缓存了版本号${version}, 但是数据没有缓存`);
        }else{
            resolve(JSON.parse(cache));
        }
    });
}

export function cacheLocationData(lang, version, data) {
    localStorage.setItem(CURRENT_CACHED_LOCATION, data);
    localStorage.setItem(CURRENT_CACHED_LOCATION_VERSION, version);
    localStorage.setItem(CURRENT_CACHED_LOCATION_LANG, lang);
}

/**
 * 将内容文本转化为数组
 * @param content {String} 内容文本
 * @returns {Object[]}
 */
function convertContentTextToLocationData(content) {
    return JSON.parse(content.split(/[()]/)[1]);
}
/**
 * 通过传入版本号，从缓存中或者后端接口中获取最新版本的地区数据
 * @param {string} [lang=] - 语言代号
 * @param {number} [version=] - 版本号
 * @param {string} [tenantId=] - 租户ID
 * @returns {Promise<Object[]>} - 地区数组
 */
function getLocationDataFromApi(lang = 'chs',version = 50, tenantId = '100000') {
    const LOCATION_DATA_URL = `//const.italent.cn/resource/Areas-${lang}-${version}-${tenantId}.js`;
    if(getLocationDataFromApi.result === undefined) {
        getLocationDataFromApi.result = fetch(LOCATION_DATA_URL)
            .then(res => res.text())
            .then(content => convertContentTextToLocationData(content))
            .then(data => convertDataToLocationNeeded(data))
            .then(data => {
                cacheLocationData(lang,version,JSON.stringify(data));
                return data;
            }).catch(err => {
                console.error(err);
            });
    }
    return getLocationDataFromApi.result;
}

function isVersionLatestCached(version) {
    const currentCachedVersion = localStorage.getItem(CURRENT_CACHED_LOCATION_VERSION);
    if(currentCachedVersion == null) return false;
    return currentCachedVersion >= version;
}

function isCurrentLangCached(lang = 'chs') {
    const currentCachedLang = localStorage.getItem(CURRENT_CACHED_LOCATION_LANG);
    return currentCachedLang === lang;
}

/**
 * 通过传入版本号，从缓存中或者后端接口中获取最新版本的地区数据
 * @param {string} [lang=] - 语言代号
 * @param {number} [version=] - 版本号
 * @param {string} [tenantId=] - 租户ID
 * @returns {Object[]} - 地区数组
 */
export function getLocationData(lang = 'chs',version = 50, tenantId = '100000') {
    return isVersionLatestCached(version) && isCurrentLangCached(lang) ? getLocationDataFromCache(version) : getLocationDataFromApi(lang, version, tenantId);
}

export function getTenantID() {
  const { loginUserInfo = {} } = window.BSGlobal || {};
  const { TenantID = '100000' } = loginUserInfo;
  return TenantID;
}

export function getCurrentLang() {
  const { I18NInfo = {} } = window.BSGlobal || {};
  const { I18NUserLang = 'zh_CN' } = I18NInfo;
  return I18NUserLang;
}

export function getAreaVersion() {
    const LOCATION_DATA_VERSION_URL = `//const.italent.cn/api/setting/${getTenantID()}`;
    if (getAreaVersion.result === undefined) {
        getAreaVersion.result = fetch(LOCATION_DATA_VERSION_URL)
            .then(res => res.json())
            .then(data => (
                data.Version
            )).catch(err => {
                console.error(err);
            });
    }
    return getAreaVersion.result;
}




// WEBPACK FOOTER //
// ./src/components/Field_Components/PopArea/getAreaData.js